import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './NotFound.css';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="notfound-page">
      <Navbar />
      <div className="notfound-content">
        <div className="notfound-code">404</div>
        <h1 className="notfound-title">Pagina niet gevonden</h1>
        <p className="notfound-text">
          De pagina die je zoekt bestaat niet of is verplaatst.
        </p>
        <div className="notfound-actions">
          <button className="notfound-btn-primary" onClick={() => navigate('/')}>
            Terug naar home
          </button>
          <button className="notfound-btn-secondary" onClick={() => navigate(-1)}>
            Vorige pagina
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
